import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const knowledgeHubBrowseViewArticleRoute: InvariantJiraRoute = {
	name: 'knowledge-hub-browse-view-article',
	path: '/jira/servicedesk/projects/:projectKey/knowledge/articles/:articleId',
};
